<div class="sc-phone" [class.has-error]="hasErrorAreaCode || hasErrorPhoneNumber">
  <label *ngIf="label" [attr.for]="idAreaCode" class="sc-phone__label">{{ label }}</label>
  <div class="sc-phone__input-group d-flex">
    <div class="d-flex sc-phone__code-area">
      <sc-input [id]="idAreaCode" [formControl]="formControlAreaCode" type="number" [placeholder]="placeholderAreaCode" [value]="valueAreaCode" [isDisabled]="isDisabledAreaCode"  [addOnPrefix]="areaCodePrefix" class="fluid-input"
        [hideError]="true" [errorMessages]="errorMessages" (focus)="onFocus($event,formControlAreaCode)"
        (blur)="onBlur($event)"></sc-input>
    </div>
    <div class="d-flex sc-phone__phone-number">
      <sc-input [id]="idPhoneNumber" [formControl]="formControlPhoneNumber" type="number" [placeholder]="placeholderPhoneNumber" [value]="valuePhoneNumber"  [isDisabled]="isDisabledPhoneNumber" [addOnPrefix]="phoneNumberPrefix" class="fluid-input"
        [hideError]="true" [errorMessages]="errorMessages" (focus)="onFocus($event,formControlPhoneNumber)"  
        (blur)="onBlur($event)"></sc-input>
    </div>
  </div>
  <div class="sc-phone__error-list" *ngIf="errorsList">
    <ul class="sc-phone__error-list has-error" >
      <li class="sc-phone__error-list__item" *ngFor="let error of errorsList">{{error}}</li>
    </ul>
  </div>

</div>